<aside
  [class]="
    'h-full bg-surface-bg-generic-white flex flex-col transition-all duration-300 flex-shrink-0 ' +
    containerClass()
  ">
  <!-- Sidebar Content -->
  <div class="flex-1 overflow-y-auto py-4">
    <!-- Menu Items -->
    <nav class="space-y-1 ps-6 pe-6">
      @for (item of menuItems(); track item.id) {
      <!-- Menu Item -->
      <div>
        <!-- Main Menu Button -->
        <button
          type="button"
          [id]="'sidebar_nav_' + item.id"
          data-action-feedback="off"
          (click)="item.children ? toggleDropdown(item.id) : handleMenuClick(item)"
          [class]="
            'w-full flex items-center justify-center gap-3 px-measure-sm py-measure-2xs text-start transition-all duration-200 rounded-lg ' +
            (isDrawer() ? 'min-h-11 ' : '') +
            (isActive(item)
              ? 'bg-surface-bg-primary-faint text-typography-primary-strong font-medium'
              : 'text-typography-neutral-solid hover:bg-surface-bg-neutral-subtle')
          "
          [attr.aria-label]="item.label"
          [attr.aria-expanded]="item.children ? isDropdownOpen(item.id) : null">
          <!-- Icon + Label -->
          <div class="flex items-center gap-3 flex-1 min-w-5">
            <!-- Icon -->
            @if (item.icon === 'dashboard') {
            <lib-dashboard-icon width="20" height="20" class="flex-shrink-0" />
            } @else if (item.icon === 'admin') {
            <lib-admin-icon width="20" height="20" class="flex-shrink-0" />
            } @else if (item.icon === 'organization') {
            <lib-organization-icon
              width="20"
              height="20"
              class="flex-shrink-0" />
            } @else if (item.icon === 'projects') {
            <lib-projects-icon width="20" height="20" class="flex-shrink-0" />
            } @else if (item.icon === 'financial') {
            <lib-financial-icon width="20" height="20" class="flex-shrink-0" />
            } @else if (item.icon === 'reports') {
            <lib-reports-icon width="20" height="20" class="flex-shrink-0" />
            } @else if (item.icon === 'resource-management') {
            <lib-resource-management-icon
              width="20"
              height="20"
              class="flex-shrink-0" />
            } @else if (item.icon === 'document-centre') {
            <lib-contracts-icon width="20" height="20" class="flex-shrink-0" />
            } @else if (item.icon === 'receipt-text') {
            <lib-receipt-text-icon
              width="20"
              height="20"
              class="flex-shrink-0" />
            }

            <!-- Label (hidden when collapsed) -->
            @if (showLabels()) {
            <span class="truncate">{{ item.label }}</span>
            }
          </div>

          <!-- Dropdown Chevron (only if has children and expanded) -->
          @if (item.children && showLabels()) {
          <lib-chevron-down-icon
            width="16"
            height="16"
            [class]="
              'flex-shrink-0 transition-transform duration-200 ' +
              (isDropdownOpen(item.id) ? 'rotate-180' : '')
            " />
          }
        </button>

        <!-- Sub-menu (Dropdown) -->
        @if (item.children && isDropdownOpen(item.id) && showLabels()) {
        <div class="mt-1 space-y-1 ps-3 pe-3">
          @for (child of item.children; track child.id) {
          <button
            type="button"
            [id]="'sidebar_nav_' + child.id"
            data-action-feedback="off"
            (click)="handleMenuClick(child)"
            [class]="
              'w-full flex items-center ps-9 pe-3 text-start transition-all duration-200 text-sm rounded-lg ' +
              (isDrawer() ? 'min-h-11 py-2.5 ' : 'py-2 ') +
              (isActive(child)
                ? 'bg-surface-bg-primary-faint text-typography-primary-strong font-medium'
                : 'text-typography-neutral-active hover:bg-surface-bg-neutral-faint')
            "
            [attr.aria-label]="child.label">
            <!-- Sub-menu Label (No Icons) -->
            <span class="truncate">{{ child.label }}</span>
          </button>
          }
        </div>
        }
      </div>
      }
    </nav>
  </div>

  <!-- Bottom Section: Collapse/Expand Toggle + Sign Out -->
  <div class="p-6 space-y-2">
    <!-- Toggle Sidebar Button (docked mode only) -->
    @if (!isDrawer()) {
    <button
      type="button"
      id="sidebar_toggle_btn"
      data-action-feedback="off"
      (click)="toggleSidebar()"
      class="w-fit cursor-pointer flex items-center px-3 py-2.5 text-typography-neutral-solid hover:bg-surface-bg-neutral-subtle transition-all duration-200 rounded-lg"
      [class.justify-start]="isExpanded()"
      [class.justify-center]="!isExpanded()"
      [attr.aria-label]="isExpanded() ? 'Collapse Sidebar' : 'Expand Sidebar'">
      <lib-arrow-left-icon
        width="20"
        height="20"
        fill="none"
        [class]="
          'flex-shrink-0 transition-transform duration-300 ' +
          (isExpanded() ? '' : 'rotate-180')
        " />
    </button>
    }

    <!-- Sign Out Button -->
    <div
      class="border-t border-border-neutral-soft"
      [class.pt-6]="!isDrawer()"
      [class.pt-4]="isDrawer()">
      <button
        type="button"
        id="sidebar_sign_out_btn"
        (click)="handleSignOut()"
        class="cursor-pointer w-full flex items-center justify-center gap-3 px-3 py-2.5 text-typography-neutral-strong hover:text-typography-destructive-strong hover:bg-surface-bg-destructive-faint transition-all duration-200 rounded-lg"
        [class.min-h-11]="isDrawer()"
        aria-label="Sign Out">
        <lib-sign-out-icon width="20" height="20" class="flex-shrink-0" />
        @if (showLabels()) {
        <span class="flex-1 text-start">Sign out</span>
        }
      </button>
    </div>
  </div>
</aside>
